import React, { useState, useContext } from "react";
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import { regionalApprovals, getApplicationById, getRegionPresident } from "../../../api/apiServices";
import AuthContext from "../../../context/AuthProvider";
import 'react-confirm-alert/src/react-confirm-alert.css';
import toast, { Toaster } from 'react-hot-toast'


const RegionForm = (props) => {

    const { auth } = useContext(AuthContext)
    const params = useParams();
    const id = parseInt(params.id)
    // const [newApplication, setNewApplication] = useState([]);
    // const [region_president, setRegionPresident] = useState("");
    const [regional_approval_rejection_reason, setReason] = useState("");


    const {
        data: newApplication,
    } = useQuery(['newApplication', id], () => getApplicationById(id));

    const {
        data: region_president
    } = useQuery(
        newApplication?.region_code?.length ? ["region_president", newApplication?.region_code] : null,
        () => getRegionPresident(newApplication?.region_code),

    )

    let application_id = newApplication?.id;
    let dateJoined = new Date(newApplication?.date_joined)
    let applicationYear = String(dateJoined.getFullYear());

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/regional_approvals";

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!regional_approval_rejection_reason) {
            toast.error("Please provide reason for approving the application")
            return false
        }

        const data = {
            application_id: application_id,
            year: applicationYear,
            regional_approved_status: true,
            regional_approval_rejection_reason: regional_approval_rejection_reason
        }
        regionalApprovals(data).then((res) => {
            toast.success("Member application successfully approved", {
                duration: 5000
            });
            navigate(from, { replace: true });
        })
    }

    const handleDecline = (e) => {
        e.preventDefault();
        if (!regional_approval_rejection_reason) {
            toast.error("Please provide reason for declining the application", {
                duration: 5000,
            })
            return false
        }

        const data = {
            application_id: application_id,
            year: applicationYear,
            regional_approved_status: false,
            regional_approval_rejection_reason: regional_approval_rejection_reason,
        }
        regionalApprovals(data).then((res) => {
            toast.success("Member application declined");
            // setNewApplication([])
            navigate(from, { replace: true });
        })
    }

    const handleCancel = (e) => {
        e.preventDefault();
        navigate(from, { replace: true });
    }


    const content = (
        <div className="panel panel-success panel-br-4">
            <div className="panel-heading">
                <div className="row">
                    <div className="col-sm-9">
                        <h4 className="panel-title">
                            <i className="fa fa-file-text" aria-hidden="true"></i>
                            <span> Application Details</span>
                        </h4>
                    </div>
                </div>
            </div>
            <div className="panel-body">
                <div className="table-responsive lg">
                    <table className="table table-borderless">
                        <tbody>
                            <><tr>
                                <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>NDC Number</td>
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{newApplication?.ndc_membership_number}</td>
                                <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>VoterID Number</td>
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{newApplication?.voter_id_number}</td>
                                <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Application Date</td>
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "no-wrap" }}> :	{newApplication?.date_joined}</td>

                            </tr><tr>
                                    <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>LastName</td>
                                    <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{newApplication?.last_name}</td>
                                    <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>FirstName</td>
                                    <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{newApplication?.first_name}</td>
                                    <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>MiddleName</td>
                                    <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{newApplication?.middle_name}</td>
                                </tr><tr>
                                    <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Email</td>
                                    <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{newApplication?.email}</td>
                                    <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Phone Number</td>
                                    <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{newApplication?.mobile_number}</td>
                                    <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Gender</td>
                                    <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{newApplication?.gender}</td>
                                </tr>
                                <tr>
                                    <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Region</td>
                                    <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{newApplication?.region}</td>
                                    <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Constituency</td>
                                    <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{newApplication?.constituency}</td>
                                    <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Branch</td>
                                    <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{newApplication?.branch}</td>
                                </tr>
                                <tr>
                                    <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Recommended By</td>
                                    <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{newApplication?.recommended_by}</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td colSpan={4}>
                                        <strong style={{ fontSize: "18px", fontWeight: "700", color: "brown" }}>Regional President Information</strong>
                                    </td>
                                    <td colSpan={2}>
                                        <strong style={{ fontSize: "18px", fontWeight: "700", color: "brown" }}><a className="a-link"rel="noreferrer" target="_blank" href="https://www.ndcpayment.com/dues/pay">Click to verify applicant NDC applicationship</a></strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Name</td>
                                    <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{region_president?.fullname}</td>
                                    <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Mobile Number</td>
                                    <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{region_president?.mobile_number}</td>
                                    <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Email</td>
                                    <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{region_president?.email}</td>
                                </tr>
                            </>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )

    const approvalForm = (
        <div className="panel panel-success panel-br-4">
            <div className="panel-heading">
                <div className="row">
                    <div className="col-sm-9">
                        <h4 className="panel-title">
                            <i className="fa fa-file-text" aria-hidden="true"></i>
                            <span> Application Approval/Decline</span>
                        </h4>
                    </div>
                </div>
            </div>
            <div className="panel-body">
                <form onSubmit={handleSubmit}>
                    <div className="form-group row">
                        <label htmlFor="reason" className="col-sm-3">Approval/Decline Reason</label>
                        <div className="col-sm-6">
                            <textarea
                                rows="4"
                                type="textarea"
                                id="reason"
                                placeholder="Type reason for approval or decline"
                                autoComplete="off"
                                onChange={(e) => setReason(e.target.value)}
                                value={regional_approval_rejection_reason}
                                name="reason"
                                className="form-control"
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label htmlFor="" className="col-sm-3 col-form-label"></label>
                        <div className="col-sm-2">
                            <button type="submit" className="btn btn-danger btn-block" onClick={handleDecline}>
                                Decline
                            </button>
                        </div> &nbsp;&nbsp;
                        <div className="col-sm-2">
                            <button type="submit" className="btn btn-success btn-block">
                                Approve
                            </button>
                        </div> &nbsp;&nbsp;
                        <div className="col-sm-2">
                            <button type="submit" className="btn btn-warning btn-block" onClick={handleCancel}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )

    return (
        <><section className="content-header">
            <Toaster toastOptions={{ position: "top-center" }} />
            <h1>Regional - Application Approval</h1>
        </section>
            <section className="content">
                <div className="box">
                    <div className="box-body">
                        <div className="panel panel-default panel-br-4">
                            <div className="panel-heading">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h4 className="panel-title">
                                            <span> Application Approval </span>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div className="panel-body">
                                {content}
                            </div>
                            <div className="panel-footer">
                                {approvalForm}
                            </div>
                        </div>
                    </div>
                    <div className="box-body"></div>
                </div>
            </section></>
    );
}

export default RegionForm;